import axios from 'axios'
import { BASE_URL } from './constants.js'

let getTokenFn = null

export const setTokenGetter = (fn) => {
  getTokenFn = fn
}

const api = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
})

api.interceptors.request.use(
  async (config) => {
    if (getTokenFn) {
      try {
        const token = await getTokenFn()
        if (token) {
          config.headers.Authorization = `Bearer ${token}`
        }
      } catch (err) {
        console.error('Failed to get access token:', err)
      }
    }
    return config
  },
  (error) => Promise.reject(error),
)

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect on 401 (unauthorized), NOT on 403 (forbidden)
    // 403 means the user is authenticated but the endpoint rejected — app should handle gracefully
    if (error.response?.status === 401 && !window.location.pathname.includes('/login')) {
      window.location.href = '/login'
    }
    return Promise.reject(error)
  },
)

export default api
